import { styled } from 'styled-components';

export const ContainerSC = styled.div`
  max-width: ${(props) => props.theme.dimensions.containerMaxWidth};
  padding-inline: 1rem;
`;

export const VerticalLineSC = styled.div<{ $color?: string }>`
  height: auto;
  border-left: 1px solid;
  border-color: ${(props) => (props.$color ? props.$color : props.theme.colors.oxfordBlue[80])};
  width: 1px;
`;

export const HorizontalLineSC = styled.div<{ $color?: string }>`
  height: 1px;
  width: 100%;
  background-color: ${(props) => (props.$color ? props.$color : props.theme.colors.slateGray[50])};
`;

export const LeftColSC = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  ${(props) => (props.theme.isRtl ? `right: 0` : `left: 0`)}
`;

export const RightColSC = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  ${(props) => (props.theme.isRtl ? `left: 0` : `right: 0`)}
`;
